import { render } from "./ScriptFormPage.vue?vue&type=template&id=4b43818d&ts=true"
import script from "./ScriptFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScriptFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/script/ScriptFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b43818d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b43818d', __exports__)) {
    api.reload('4b43818d', __exports__)
  }
  
  module.hot.accept("./ScriptFormPage.vue?vue&type=template&id=4b43818d&ts=true", () => {
    api.rerender('4b43818d', render)
  })

}


export default __exports__